import infiniteobjectsUiGlobalScript from '/Volumes/InfiniteObjects/stack/libraries/ui-library/dist/collection/global/init.js';
import ioPrintButtonGlobalScript from '/Volumes/InfiniteObjects/stack/libraries/ui-print-button/src/global/init.ts';
export const globalScripts = () => {
  return Promise.all([
    ioPrintButtonGlobalScript(),
    infiniteobjectsUiGlobalScript(),
  ]);
};
